var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileMoneyOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a1 1 0 011 1v.537c1.122.128 2.185.436 2.857.805a1 1 0 11-.964 1.753c-.381-.21-1.094-.428-1.893-.542v3.469c.568.2 1.163.439 1.66.76.81.521 1.472 1.33 1.472 2.569 0 1.047-.35 1.916-1.017 2.546-.59.559-1.35.854-2.115.995V19a1 1 0 11-2 0v-1.027a13.035 13.035 0 01-3.338-.732 1 1 0 11.676-1.882c.85.305 1.788.526 2.662.607v-3.51c-.65-.23-1.351-.521-1.93-.946-.823-.603-1.422-1.493-1.422-2.778 0-1.096.48-1.933 1.247-2.474.619-.436 1.374-.647 2.105-.734V5a1 1 0 011-1zm-1 3.545c-.414.072-.735.194-.953.348-.24.17-.399.4-.399.839 0 .551.212.877.604 1.165.21.154.46.287.748.413V7.545zm2 5.618v2.676c.33-.1.573-.237.74-.395.216-.203.392-.52.392-1.093 0-.382-.149-.627-.555-.889a3.936 3.936 0 00-.577-.299z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1a1 1 0 011-1h18a1 1 0 011 1v22a1 1 0 01-1 1H3a1 1 0 01-1-1V1zm2 1v20h16V2H4z"
  })));
}
export default SvgFileMoneyOutline;